import Signin from '../components/Signin';
import ForgotPassword from '../components/ForgotPassword';
import ResetPassword from '../components/ResetPassword';
import TicketsPage from '../components/TicketsPage';
import DashboardPage from '../components/DashboardPage';
import LoginLayout from '../components/LoginLayout.vue';
import AppLayout from '../components/AppLayout.vue';
import MobileFullPageAppLayout from '../components/MobileFullPageAppLayout';
import ResetPasswordLayout from '../components/ResetPasswordLayout.vue';
import PlaceHolderComponent from '../components/PlaceHolderPage';
import MessagesPage from '../components/Messages/MessagesPage';
import TicketAlertsPage from '../components/TicketAlerts/TicketAlertsPage';
import ProfileRoute from '../components/ProfileSettings/ProfileRoute';
import UserInfoRoute from '../components/ProfileSettings/UserInfoRoute';
import ChangePasswordRoute from '../components/ProfileSettings/ChangePasswordRoute';
import AlertPreferences from '../components/ProfileSettings/AlertPreferencesRoute';
import EmailRoute from '../components/ProfileSettings/EmailRoute';
import TicketMap from '../components/Map/TicketMap';
import TicketDetailsPage from '../components/TicketDetails/TicketDetailsPage';
import RevisionsDetails from '../components/TicketDetails/RevisionsDetails';
import OfflineClipboard from '../components/Offline/OfflineClipboard';
import MemberCodeList from '../components/Settings/MemberCode/MemberCodeList';
import ResponseCodeList from '../components/Settings/ResponseCode/ResponseCodeList';
import UsersList from '../components/Settings/Users/UsersList';
import Users from '../components/Settings/Users/Users';
import MapLayers from '../components/Settings/MapLayers/MapLayers';
import UploadMapLayer from '../components/Settings/MapLayers/UploadMapLayer';
import DrawMapLayer from '../components/Settings/MapLayers/DrawMapLayer';
import AutoRespondRules from '../components/Settings/AutoRespond/AutoRespondRules';
import AutoRespondRuleForm from '../components/Settings/AutoRespond/AutoRespondRuleForm';
import AutoAssignRules from '../components/Settings/AutoAssignRules/AutoAssignRules';
import AddAutoAssignRule from '../components/Settings/AutoAssignRules/AddAutoAssignRule';
import BillingCodes from '../components/Settings/BillingCodes/BillingCodes';
import BillingRatePeriods from '../components/Settings/BillingRules/BillingRatePeriods';
import ArchivesPage from '../components/History/Archives/Archives';
import AddSupplementalMessage from '../components/Settings/SupplementalMessages/AddSupplementalMessage';
import EmailQueue from '../components/Queues/EmailQueue';
import CenterResponseQueue from '../components/Queues/CenterResponseQueue';
import SupplementalMessagesList from '../components/Settings/SupplementalMessages/SupplementalMessagesList';
import TicketClipboardRouting from '../components/TicketClipboardRouting';
import LocatorLogixEODReport from '../components/History/EOD/LocatorLogixEODReport';
import CenterEODAudit from '../components/History/EOD/CenterEODAudit';
import Reports from '../components/Reports/Reports';
import ReportList from '../components/Reports/ReportList';
import EventLog from '../components/History/EventLog';

export const routes = [
    {
        path: '/signin',
        component: Signin,
        meta: {
            layout: LoginLayout,
            authenticationNotRequired: true,
        },
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        meta: {
            layout: LoginLayout,
            authenticationNotRequired: true,
        },
    },
    {
        path: '/reset-password',
        component: ResetPassword,
        meta: {
            layout: ResetPasswordLayout,
            authenticationNotRequired: true,
        },
    },
    {
        path: '/tickets',
        component: TicketsPage,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                icon: '$vuetify.icons.ticketIcon',
                title: 'Tickets',
            },
        },
    },
    {
        path: '/tickets/details',
        component: TicketDetailsPage,
        meta: {
            layout: AppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/tickets/details/revisionsdetails',
        component: RevisionsDetails,
        meta: {
            layout: AppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/tickets/alerts',
        component: TicketAlertsPage,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/tickets/clipboard/routing',
        component: TicketClipboardRouting,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/dashboard',
        component: DashboardPage,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                icon: 'dashboard',
                title: 'Dashboard',
            },
        },
    },
    {
        path: '/reports',
        component: Reports,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                icon: '$vuetify.icons.reportIcon',
                title: 'Reports',
            },
        },
    },
    {
        path: '/reportList',
        component: ReportList,
        meta: {
            layout: AppLayout,
        },
    },
    {
        path: '/queues',
        component: PlaceHolderComponent,
        meta: {
            navDrawerItem: {
                icon: '$vuetify.icons.queueIcon',
                title: 'Queues',
                noNavLink: true,
            },
        },
    },
    {
        path: '/queues/email',
        component: EmailQueue,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                title: 'Email',
            },
            title: 'Queues',
            noNavLink: true,
            ingroups: ['LOCATOR','DISPATCHER','ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/queues/postitive-response',
        component: CenterResponseQueue,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                title: 'Center +Response',
            },
            rbacNotRequired: true,
            ingroups: ['DISPATCHER', 'ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/profile',
        component: ProfileRoute,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/profile/user-info',
        component: UserInfoRoute,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/profile/change-password',
        component: ChangePasswordRoute,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/profile/alert-preferences',
        component: AlertPreferences,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/profile/email',
        component: EmailRoute,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/history',
        component: PlaceHolderComponent,
        meta: {
            navDrawerItem: {
                icon: 'history',
                title: 'History',
                noNavLink: true,
            },
            permissions: ['ARCHIVES_VIEW'],
        },
    },
    {
        path: '/history/archives',
        component: ArchivesPage,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                title: 'Archives',
            },
            rbacNotRequired: true,
            permissions: ['ARCHIVES_VIEW'],
        },
    },
    {
        path: '/history/CenterEODAudit',
        component: CenterEODAudit,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                title: 'Center EOD Audit',
            },
            rbacNotRequired: true,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/history/LocatorLogixEODReport',
        component: LocatorLogixEODReport,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                title: 'Locator LOGiX EOD',
            },
            rbacNotRequired: true,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/history/EventLog',
        component: EventLog,
        meta: {
            layout: AppLayout,
            navDrawerItem: {
                title: 'Event Log',
            },
            rbacNotRequired: true,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings',
        component: PlaceHolderComponent,
        meta: {
            navDrawerItem: {
                icon: 'settings',
                title: 'Settings',
                noNavLink: true,
            },
            ingroups: ['DISPATCHER', 'ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/users',
        component: UsersList,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['DISPATCHER', 'ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
            navDrawerItem: {
                title: 'Users',
            },
        },
    },
    {
        path: '/settings/adduser',
        component: Users,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/edituser',
        component: Users,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/member-codes',
        component: MemberCodeList,
        meta: {
            layout: MobileFullPageAppLayout,
            navDrawerItem: {
                title: 'Member Codes',
            },
            permissions: ['MEMBER_CODE_MAINTENANCE'],
        },
    },
    {
        path: '/settings/response-codes',
        component: ResponseCodeList,
        meta: {
            layout: MobileFullPageAppLayout,
            navDrawerItem: {
                title: 'Response Codes',
            },
            permissions: ['RESPONSE_CODE_MAINTENANCE'],
        },
    },
    {
        path: '/settings/billing-codes/',
        component: BillingCodes,
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
            navDrawerItem: {
                title: 'Billing Codes',
            },
            permissionsAny: ['USE_BILLING_MODULE', 'USE_ENHANCED_BILLING_MODULE'],
        },
    },
    {
        path: '/settings/billing-rate-periods/',
        component: BillingRatePeriods,
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
            navDrawerItem: {
                title: 'Billing Rate Periods',
            },
            permissions: ['USE_ENHANCED_BILLING_MODULE'],
        },
    },
    {
        path: '/settings/map-layers',
        component: MapLayers,
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
            navDrawerItem: {
                title: 'Map Layers',
            },
        },
    },
    {
        path: '/settings/map-layers/draw',
        component: DrawMapLayer,
        name: 'draw-map-layer',
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/map-layers/upload',
        component: UploadMapLayer,
        name: 'upload-map-layer',
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/auto-respond-rules',
        component: AutoRespondRules,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
            navDrawerItem: {
                title: 'Auto-Respond Rules',
            },
        },
    },
    {
        path: '/settings/auto-respond-rules/new',
        component: AutoRespondRuleForm,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/auto-respond-rules/edit',
        component: AutoRespondRuleForm,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/auto-assign-rules',
        component: AutoAssignRules,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
            navDrawerItem: {
                title: 'Auto Assign Rules',
            },
        },
    },
    {
        path: '/settings/supplemental-messages',
        component: SupplementalMessagesList,
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
            navDrawerItem: {
                title: 'Supplemental Messages',
            },
        },
    },
    {
        path: '/settings/supplemental-messages/add',
        component: AddSupplementalMessage,
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/supplemental-messages/edit',
        component: AddSupplementalMessage,
        meta: {
            layout: AppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/auto-assign-rules/new',
        component: AddAutoAssignRule,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/settings/auto-assign-rules/edit',
        component: AddAutoAssignRule,
        meta: {
            layout: MobileFullPageAppLayout,
            ingroups: ['ADMINISTRATOR', 'DIRECTOR', 'SYSOP'],
        },
    },
    {
        path: '/messages',
        component: MessagesPage,
        meta: {
            layout: MobileFullPageAppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/map',
        component: TicketMap,
        meta: {
            layout: AppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/offline/tickets',
        component: OfflineClipboard,
        meta: {
            layout: AppLayout,
            rbacNotRequired: true,
        },
    },
    {
        path: '/offline/tickets/details',
        component: TicketDetailsPage,
        meta: {
            layout: AppLayout,
            rbacNotRequired: true,
        },
    },
];
